import React from "react";
import { ValidationError } from "../../../common/lib/validation";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input as BootstrapInput,
  FormFeedback,
  Button
} from "reactstrap";
import ReactDropzone from "react-dropzone";

class Dropzone extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      field,
      title,
      placeholder,
      loading,
      preview,
      clearError,
      error,
      onDrop,
      onDelete
    } = this.props;

    return (
      <FormGroup
        color={ValidationError.isInvalid(error, field) ? "danger" : ""}
        row
      >
        <Label for={field} xs="2">{title}</Label>
        <Col xs="10">
          <ReactDropzone
            activeClassName="dropzone-active"
            className={
              ValidationError.isInvalid(error, field)
                ? "dropzone dropzone-wrapper dropzone-error"
                : "dropzone dropzone-wrapper"
            }
            onDrop={onDrop}
          >
            <div className="dropzone-inside">
              {preview &&
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={onDelete}
                >
                  <span aria-hidden="true">×</span>
                </button>}
              <div className="dropzone-text">
                {loading
                  ? <i className="fa fa-circle-o-notch fa-spin" />
                  : preview
                      ? <img className="dropzone-image" src={preview} />
                      : placeholder}
              </div>
            </div>
          </ReactDropzone>
          {ValidationError.isInvalid(error, field) &&
            <FormFeedback>
              {ValidationError.getError(error, field)}
            </FormFeedback>}
        </Col>
      </FormGroup>
    );
  }
}

export default Dropzone;



// WEBPACK FOOTER //
// ./src/browser/components/Form/Dropzone.js